import { CategoriaNotificacaoType } from '_metronic/helpers'

const CATEGORIA_COR: Record<CategoriaNotificacaoType, string> = {
  [CategoriaNotificacaoType.Atendimento]: '#4ec98a',
  [CategoriaNotificacaoType.Financeiro]: '#e0b34e',
  [CategoriaNotificacaoType.Sistema]: '#9b5cc4',
  [CategoriaNotificacaoType.Geral]: 'var(--bs-secondary-color)',
}

type Props = {
  categoria?: CategoriaNotificacaoType
  className?: string
}

export const NotificacaoIcone = ({ categoria, className = 'flex-shrink-0 mt-1' }: Props) => {
  const cor = categoria ? CATEGORIA_COR[categoria] : 'var(--bs-secondary-color)'

  if (categoria === CategoriaNotificacaoType.Atendimento) {
    return (
      <svg
        width='17'
        height='17'
        viewBox='0 0 24 24'
        fill='none'
        stroke={cor}
        strokeWidth='2'
        className={className}
      >
        <path d='M20 6L9 17l-5-5' />
      </svg>
    )
  }

  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 24 24'
      fill='none'
      stroke={cor}
      strokeWidth='1.9'
      className={className}
    >
      <circle cx='12' cy='12' r='9' />
      <path d='M12 8v5M12 16h.01' />
    </svg>
  )
}
